<template>
     <!--定点投放--投放统计--查看页面 对话框 -->

    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="75%" :before-close="closeDialog">
        <div>
            <div style="font-weight: 700; font-size: 20px; text-align: center; margin-bottom: 20px">投放统计查看</div>
            <el-button style="margin-bottom: 10px; float: right" type="primary"  @click="getOverView(data)"
                >扫码概览</el-button
            >
        </div>
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="consumer.name" label="扫码人"> </el-table-column>
            <el-table-column prop="scan_time" label="扫码时间"> </el-table-column>

            <el-table-column prop="name" label="扫码地点"> </el-table-column>
            <el-table-column prop="order_code" label="订单"> </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
               
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data_child.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data_child.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <!-- 扫码概览组件 -->

        <getOverView :isShow="tou_isShow" :data="gaiLanData"></getOverView>
    </el-dialog>
</template>

<script>
let _this;
import getOverView from './getOverView.vue';
export default {
    components: {
        getOverView
    },
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data_child.promotion_qr_code = _this.data.promotion_qr_code;
            _this.search_data_child.promotion_category_code = _this.data.promotion_category_code;
    

            _this.searchGetView();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            gaiLanData: {},
            tableData: [],
            result_data: {
                count:0,
                data:[]
            },
            tou_isShow: false,
            search_data_child: {
                page: 1,
                limit: 10,
                promotion_qr_code: '',
                promotion_category_code: '',
    

            }
        };
    },
    methods: {
        getOverView() {
   
            _this.tou_isShow = !_this.tou_isShow;
            _this.gaiLanData.promotion_category_code = _this.data.promotion_category_code;
            _this.gaiLanData.promotion_qr_code = _this.data.promotion_qr_code;
            _this.gaiLanData.district = '';
     

        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            
            _this.gaiLanData = {};
            _this.tableData = [];
            _this.result_data = {
                count:0,
                data:[]
            };
            _this.search_data_child = {
                page: 1,
                limit: 10,
                promotion_qr_code: '',
                promotion_category_code: '',
   

            };
        },

        getView() {
            _this.$post('/promotion/getView', _this.search_data_child).then((res) => {
                _this.result_data = res;
      
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data_child.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_child.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.getView();
        },
        searchGetView() {
            _this.search_data_child.page = 1;
     
            _this.getView();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
